import Section from "../section";


export default class Rentals extends Section {

  constructor(calculator) {
    super(calculator);

    this.form.find('.catcalc-rentals-tables input,' +
      '.catcalc-rentals-dishes input').on('change', ()=>{
      this.updateTablesCost();
      this.updateDishesCost();
      this.form.trigger('catcalc.change');
    });
  }

  get tables() {
    let field = this.form.find('.catcalc-rentals-tables input:checked')
    if (field.length) {
      return field.val().toLowerCase()
    }
  }

  get dishes() {
    let field = this.form.find('.catcalc-rentals-dishes input:checked')
    if (field.length) {
      return field.val().toLowerCase()
    }
  }

  updateTablesCost() {
    let summaryEl = this.form.find('.catcalc--summary-rentals-tables');
    let subtotalEl = this.form.find('.catcalc-rentals-tables-cost input');

    if (this.tables == 'yes') {
      subtotalEl.val(this.calculator.event.guests * 9);
    } else {
      subtotalEl.val(0);
    }

    summaryEl.find('.choice').html(this.tables);
    summaryEl.find('.cost').html("$" + subtotalEl.val());
  }

  updateDishesCost() {
    let summaryEl = this.form.find('.catcalc--summary-rentals-dishes');
    let subtotalEl = this.form.find('.catcalc-rentals-dishes-cost input');

    if (this.dishes == 'yes') {
      subtotalEl.val(this.calculator.event.guests * 12);
    } else {
      subtotalEl.val(0);
    }

    summaryEl.find('.choice').html(this.dishes);
    summaryEl.find('.cost').html("$" + subtotalEl.val());
  }

  total() {
    let total = 0;
    if(this.tables == 'yes'){
      total += this.calculator.event.guests * 9;
    }
    if (this.dishes == 'yes') {
      total += this.calculator.event.guests * 12;
    }
    return total;
  }

}




// WEBPACK FOOTER //
// ./scripts/catcalc/sections/rentals.js